export default __webpack_public_path__ + "static/media/login-elsa-logo-icon.9507883a.svg";